import React from 'react'
import { Flex } from 'components'
import { WatermarkDrawer } from '../Drawers'

export default () => (
  <Flex column>
    <WatermarkDrawer margin="24px 16px" />
  </Flex>
)
